export const AllCollaborateRoutes = {
  index: "/collaborate",
};
